import { FormatNumberOpts } from '../../utils/format-number';
import { Mode, Variant } from './chart-box.use-mode-select';
import { StatisticsUnit } from '../../../../core/src/shared/statistics-config';
import { colors } from '../../theme/palette';

export const getNumberFormat = (
  value: number,
  unit: StatisticsUnit,
  mode: Mode,
  variant: Variant
) => {
  const getKilowatt = () => {
    if (mode === Mode.Year) {
      return 'megawatt-hour';
    }

    return variant === Variant.Bar || variant === Variant.BarStacked
      ? 'kilowatt-hour'
      : 'kilowatt';
  };

  const mapping: Record<StatisticsUnit, FormatNumberOpts> = {
    [StatisticsUnit.Kilowatt]: {
      unit: getKilowatt(),
      style: 'unit',
      maximumFractionDigits: mode === Mode.Year ? 2 : 1,
      minimumFractionDigits: mode === Mode.Year ? 2 : 1,
    },
    [StatisticsUnit.Percent]: { style: 'percent', maximumFractionDigits: 0 },
    [StatisticsUnit.Celsius]: {
      unit: 'celsius',
      style: 'unit',
      maximumFractionDigits: 0,
    },
    [StatisticsUnit.MeterPerSecond]: {
      unit: 'meter-per-second',
      style: 'unit',
      maximumFractionDigits: 0,
    },
    [StatisticsUnit.Ampere]: {
      unit: 'ampere',
      style: 'unit',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    },
  };

  const opts = mapping[unit];

  const adjustedValue = opts.unit === 'megawatt-hour' ? value / 1000 : value;

  return [adjustedValue, opts] as const;
};

export const getSubStatColor = (index: number, total: number) => {
  const minOpacity = 0.2;
  const step = total > 1 ? (1 - minOpacity) / (total - 1) : 0;
  return hexWithOpacity(colors.primary, 1 - index * step);
};

function hexWithOpacity(hex: string, opacity: number) {
  hex = hex.replace('#', '');

  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0');

  return `#${hex}${alpha}`;
}
